import React, { useState } from "react";
import PrimaryButton from "../buttons/PrimaryButton.js";
import DropDown1 from "../dropdowns/DropDown1.js";
import Space from "../layout/Space.js";
import { useEffect } from "react";
import {
  createDoc,
  getFlutterTimeFromSeconds,
  getRefFromId,
  updateDocDataField,
} from "../models/DataFunctions.js";

import CheckBoxGrey from "../textfields/CheckBoxGrey.js";

import moment from "moment";
import SmallSpinner from "../loading/SmallSpinner.js";
import { useAppContext } from "../config/AppContext.js";
import updateDocDataFieldApi from "../api/database/updateDocDataFieldApi.js";
import createDocApi from "../api/database/createDocApi.js";
import { DatePicker, TimePicker } from "antd";
import { useSnackbar } from "notistack";
import { addActivityLog } from "../config/OnlineStatus.js";
import dayjs from "dayjs";
import RangeTimePickerGPT0 from "../textfields/RangeTimePickerGPT0.js";
import DatePickerGPT0 from "../textfields/DatePickerGPT0.js";
import DropDownGPT03 from "../dropdowns/DropDownGTP03.js";

const Revisite = ({ folder, userData, orgData, onClose, onUpdate }) => {
  const [add_to_planning, setAddToPlanning] = useState(true);
  const [include_ath, setIncludeAth] = useState(true);
  const [include_photos, setIncludePhotos] = useState(true);

  const { appState, setAppState } = useAppContext();
  const prefix = appState.dev ? appState.dev_url : appState.prod_url;

  const [missions, setMissions] = useState([
    { value: "Non conformité TEST", label: "Non conformité TEST" },
    { value: "Non conformité VMC", label: "Non conformité VMC" },
    { value: "Non conformité TEST & VMC", label: "Non conformité TEST & VMC" },
    { value: "Test intermédiaire", label: "Test intermédiaire" },
    { value: "Test final", label: "Test final" },
    { value: "Visite de chantier", label: "Visite de chantier" },
  ]);
  const [mission, setMission] = useState("");
  const [loadingData = false, setLoadingData] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);

  const { enqueueSnackbar } = useSnackbar();
  const handleClickVariant = (message, variant) => {
    enqueueSnackbar(message, { variant });
  };

  useEffect(() => {
    const fetchOperators = async () => {
      if (orgData) {
        setMission(missions[0].value);
      }
    };

    fetchOperators();
  }, [orgData]);

  const handleDateChange = (seconds, dateString) => {
    let date = getFlutterTimeFromSeconds(seconds);
    setSelectedDate(date);
  };
  const [rangeTime, setRangeTime] = useState({ start: null, end: null });
  const handleTimeRangeChange = (timeRange) => {
    if (timeRange) {
      setRangeTime(timeRange);
    }
  };
  const handleGenerateRevision = async () => {
    const selectedTime = rangeTime.start_seconds;
    const selectedTime2 = rangeTime.end_seconds;

    let new_start_seconds = selectedDate.seconds + selectedTime;

    let new_end_seconds = selectedDate.seconds + selectedTime2;
    let new_start = getFlutterTimeFromSeconds(new_start_seconds);
    let new_end = getFlutterTimeFromSeconds(new_end_seconds);

    setLoadingData(true);

    // end should be start + 1 hour and start is a timestamps
    // set hour to 8:00
    let client_name = folder.marque || "Particulier";

    let body = {
      start: new_start,
      end: new_end,
      name: folder.nom,
      master_id: folder.master_id,
      client_name: client_name,
      folder: folder.ref,
      members_id: folder.members_id,
      client_type: folder.client_type,
      pack_name: folder.pack_name,
      pack_ref: folder.pack_ref,
      ville: folder.ville,
      address: folder.address || folder.adresse, //fucked up code
      postal: folder.postal,
      title: folder.nom,
      type: "Intervention",
      revision: mission || null,
    };
    let new_event = await createDocApi("event", body, prefix);

    let revisions = folder.revisions ? folder.revisions : [];

    const dict = {
      intiation_seconds: moment().unix(),
      generate: add_to_planning,
      motif: mission,
      state: "done",
      start: new_start,
      end: new_end,
      event_ref: new_event.ref,
    };
    revisions.push(dict);

    await updateDocDataFieldApi(folder.ref, "revisions", revisions, prefix);

    handleClickVariant("Revisite programmée", "success");

    const docdataath = {
      name: "Attestation Spé à signer revisite",
      state: "locked",
      icon: "sign",
      viewers_id: folder.client_id
        ? [folder.master_id, folder.client_id]
        : [folder.master_id],
      documentxx: getRefFromId("documentxx", "lllll"),
    };
    const new_doc_ath = await createDocApi("document", docdataath, prefix);

    const docdataphotos = {
      name: "Photos revisite",
      state: "locked",
      icon: "photo",
      viewers_id: folder.client_id
        ? [folder.master_id, folder.client_id]
        : [folder.master_id],
      documentxx: getRefFromId("documentxx", "mmmmm"),
    };
    const new_doc_photos = await createDocApi(
      "document",
      docdataphotos,
      prefix
    );

    let documents = folder.documents ? folder.documents : [];

    if (include_ath) {
      documents.push(new_doc_ath.ref);
    }
    if (include_photos) {
      documents.push(new_doc_photos.ref);
    }

    await updateDocDataFieldApi(folder.ref, "documents", documents, prefix);
    handleClickVariant("Documents générés", "success");
    await addActivityLog(
      "Revisite programmée",
      folder.ref,
      orgData.id,
      userData.id,
      "revision_created",
      prefix
    );

    await onUpdate();
    onClose();
    setLoadingData(false);
  };

  return (
    <div className="flex flex-col w-c400 bg-white rounded-3xl ">
      <div className=" text-h3 flex flex-row justify-between p-4 border-b-1">
        Demande de revisite
        <div className="flex text-shadow_50 cursor-pointer" onClick={onClose}>
          Fermer
        </div>
      </div>

      <div className="flex flex-col p-4 gap-2 bg-neutral-50">
        <div className=" text-h3 text-shadow_50">
          Sélectionnez un type de revisite pour organiser une revisite avec
          votre partenaire
        </div>

        <DropDownGPT03
          label="Type de revisite"
          className="w-full bg-white"
          value={mission}
          items={missions}
          onChange={(e) => setMission(e.value)}
        ></DropDownGPT03>

        <div className="flex flex-row text-h3 gap-2 items-center  pl-1 mt-2">
          <CheckBoxGrey
            checked={include_ath}
            onChange={() => setIncludeAth(!include_ath)}
          />{" "}
          Inclure un document ATH Spé à signer
        </div>

        <div className="flex flex-row text-h3 gap-2 items-center  pl-1 mb-2">
          <CheckBoxGrey
            checked={include_photos}
            onChange={() => setIncludePhotos(!include_photos)}
          />{" "}
          Inclure un document Photos
        </div>

        <div className="flex flex-col gap-1 ">
          <DatePickerGPT0
            seconds={selectedDate?.seconds}
            onChange={handleDateChange}
            label="Sélectionner la date"
            transparent={false}
            getPopupContainer={(triggerNode) => triggerNode.parentNode} // Render dropdown relative to the modal
          />

          <RangeTimePickerGPT0
            onChange={handleTimeRangeChange}
            value={rangeTime}
            transparent={false}
          ></RangeTimePickerGPT0>
        </div>
      </div>
      <div className="flex flex-row justify-end p-4 border-t-1">
        <PrimaryButton
          onClick={handleGenerateRevision}
          disabled={
            loadingData ||
            !selectedDate ||
            !rangeTime?.start_seconds ||
            !rangeTime?.end_seconds
          }
        >
          Initier la revisite <SmallSpinner loading={loadingData} />
        </PrimaryButton>
      </div>
    </div>
  );
};

export default Revisite;
